import React, { useEffect, useMemo, useState } from "react";
import { X } from "lucide-react";
import { CHARACTER_AVATARS } from "../../lib/avatars";

export default function AvatarPickerModal({
  open,
  title = "Choose an avatar",
  initialUrl = null,
  onClose,
  onSave,
}) {
  const [selected, setSelected] = useState(initialUrl || null);

  useEffect(() => {
    if (open) setSelected(initialUrl || null);
  }, [open, initialUrl]);

  const items = useMemo(() => CHARACTER_AVATARS, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[4000] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/60"
        onClick={() => onClose?.()}
      />
      <div className="relative w-full max-w-[720px] max-h-[calc(100dvh-2rem)] rounded-2xl border border-white/10 bg-neutral-900/95 backdrop-blur-xl shadow-2xl overflow-hidden flex flex-col">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-white/10">
          <div className="text-white font-semibold">{title}</div>
          <button
            type="button"
            className="p-2 rounded-lg hover:bg-white/10 text-white/80"
            onClick={() => onClose?.()}
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 overflow-y-auto">
          <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-3">
            {items.map((a) => {
              const active = selected === a.url;
              return (
                <button
                  key={a.url}
                  type="button"
                  onClick={() => setSelected(a.url)}
                  className={
                    "aspect-square rounded-xl overflow-hidden border transition " +
                    (active
                      ? "border-emerald-400 ring-2 ring-emerald-400/40"
                      : "border-white/10 hover:border-white/30")
                  }
                  title={a.label}
                >
                  <img
                    src={a.url}
                    alt={a.label}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex items-center justify-between gap-3 px-5 py-4 border-t border-white/10">
          <button
            type="button"
            className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-white font-semibold"
            onClick={() => setSelected(null)}
          >
            Remove
          </button>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-white font-semibold"
              onClick={() => onClose?.()}
            >
              Cancel
            </button>
            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
              onClick={() => onSave?.(selected)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
